// extracted by mini-css-extract-plugin
export default {"edit-speciality-save-button-wrapper":"editSpeciality_edit-speciality-save-button-wrapper__Hiihq","speciality-detail-label":"editSpeciality_speciality-detail-label__eHhjY"};